module.exports = window["dfShared"]["datepicker"];